import moment from "moment";
import "moment/locale/es";
import { dineroDisabledMask } from "../Components/Items";

moment.locale("es");

const ticketCorteCajaPdf = (values) => {
    const datosSesion = values.sesion;
    const datosEmpresa = values.empresa;
    const datosCaja = values.caja;
    const datosUsuario = values.usuario;
    const datosVentas = values.ventas;
    const ventasDetalle = values.ventasData;
    const logo = datosEmpresa.logo?.base64Completa;

    const conceptosRetiros = [];
    let totalIngresos = 0;
    let totalRetiros = 0;

    // Procesar ingresos
    if (Array.isArray(datosSesion.ingresos)) {
        datosSesion.ingresos.forEach(ingreso => {
            const estaCancelado = ingreso.estado !== 2;
            if (!estaCancelado) {
                totalIngresos += ingreso.monto;
            }
            conceptosRetiros.push([
                {
                    text: estaCancelado ? `${ingreso.descripcion} (CANCELADO)` : ingreso.descripcion,
                    fontSize: 7,
                    style: "tableText",
                    color: estaCancelado ? "#999" : "#000",
                    decoration: estaCancelado ? "lineThrough" : ""
                },
                {
                    text: "Ingreso",
                    fontSize: 7,
                    style: "tableText",
                    alignment: "center",
                    color: estaCancelado ? "#999" : "#000"
                },
                {
                    text: dineroDisabledMask(ingreso.monto),
                    fontSize: 8,
                    style: "tableText",
                    alignment: "right",
                    color: estaCancelado ? "#999" : "#000",
                    decoration: estaCancelado ? "lineThrough" : ""
                }
            ]);
        });
    }


    // Procesar retiros
    if (Array.isArray(datosSesion.retiros)) {
        datosSesion.retiros.forEach(retiro => {
            const estaCancelado = retiro.estado !== 2;
            if (!estaCancelado) {
                totalRetiros += retiro.monto;
            }
            conceptosRetiros.push([
                {
                    text: estaCancelado ? `${retiro.descripcion} (CANCELADO)` : retiro.descripcion,
                    fontSize: 7,
                    style: "tableText",
                    color: estaCancelado ? "#999" : "#000",
                    decoration: estaCancelado ? "lineThrough" : ""
                },
                {
                    text: "Retiro",
                    fontSize: 7,
                    style: "tableText",
                    alignment: "center",
                    color: estaCancelado ? "#999" : "#000"
                },
                {
                    text: dineroDisabledMask(retiro.monto),
                    fontSize: 8,
                    style: "tableText",
                    alignment: "right",
                    color: estaCancelado ? "#999" : "#000",
                    decoration: estaCancelado ? "lineThrough" : ""
                }
            ]);
        });
    }

    // Preparar detalle de ventas ultra compacto
    const ventasCompactas = [];
    if (Array.isArray(ventasDetalle)) {
        ventasDetalle.forEach((venta, index) => { // Máximo 20 ventas
            const totalPagos = venta.totalPagos || {};
            const estaCancelada = !!venta.cancelada;
            let pagosTexto = "";

            // Crear texto ultra compacto de pagos
            if (totalPagos.efectivo > 0) pagosTexto += `E${dineroDisabledMask(totalPagos.efectivo).replace('$', '').replace(',', '')} `;
            if (totalPagos.tarjetaCredito > 0) pagosTexto += `TC${dineroDisabledMask(totalPagos.tarjetaCredito).replace('$', '').replace(',', '')} `;
            if (totalPagos.tarjetaDebito > 0) pagosTexto += `TD${dineroDisabledMask(totalPagos.tarjetaDebito).replace('$', '').replace(',', '')} `;
            if (totalPagos.vales > 0) pagosTexto += `V${dineroDisabledMask(totalPagos.vales).replace('$', '').replace(',', '')} `;
            if (totalPagos.cheque > 0) pagosTexto += `CH${dineroDisabledMask(totalPagos.cheque).replace('$', '').replace(',', '')} `;
            if (totalPagos.transferencia > 0) pagosTexto += `TR${dineroDisabledMask(totalPagos.transferencia).replace('$', '').replace(',', '')} `;

            const pagosFinal = pagosTexto.trim() || "N/A";

            ventasCompactas.push([
                {
                    text: (venta.folioChico || `V${index + 1}`).substring(0, 8), // Máximo 8 caracteres
                    fontSize: 6,
                    color: estaCancelada ? "#999" : "#000",
                    decoration: estaCancelada ? "lineThrough" : ""
                },
                // { text: moment(venta.fechaRemision || venta.fechaFactura).format("DD/MM HH:mm"), fontSize: 6 },
                {
                    text: estaCancelada ? `${pagosFinal} (CANCELADA)` : pagosFinal,
                    fontSize: 6,
                    color: estaCancelada ? "#999" : "#000",
                    decoration: estaCancelada ? "lineThrough" : ""
                },
                {
                    text: dineroDisabledMask(venta.total || 0),
                    fontSize: 7,
                    alignment: "right",
                    color: estaCancelada ? "#999" : "#000",
                    decoration: estaCancelada ? "lineThrough" : ""
                }
            ]);
        });
    }

    // Marca de agua si está cancelado
    let cancelado = {};
    if (values.estado === 0) {
        cancelado = {
            watermark: {
                text: 'CANCELADO',
                color: 'GRAY',
                opacity: 0.3,
                bold: true,
                italics: false,
                angle: -50,
                fontSize: 110
            }
        };
    }

    return {
        pageSize: { width: 206, height: "auto" }, // 80 mm de ancho, altura ajustable
        pageMargins: [10, 10, 10, 10],
        ...cancelado,
        content: [
            // Logo de la empresa
            ...(logo ? [{
                image: logo,
                fit: [141.73, 56.692],
                alignment: "center",
                margin: [0, 0, 0, 5]
            }] : []),

            // Nombre de la empresa
            {
                text: datosEmpresa.nombreComercial ? datosEmpresa.nombreComercial : (datosEmpresa.persona
                    ? datosEmpresa.nombre
                    : `${datosEmpresa.nombre} ${datosEmpresa.apellidoPaterno} ${datosEmpresa.apellidoMaterno}`),
                style: "header",
                alignment: "center",
                fontSize: 11,
                margin: [0, 0, 0, 3]
            },

            // RFC de la empresa
            {
                text: datosEmpresa.rfc,
                style: "subtext",
                alignment: "center",
                fontSize: 7,
                margin: [0, 0, 0, 8]
            },

            // Título del documento
            {
                text: "CORTE DE CAJA",
                style: "title",
                alignment: "center",
                fontSize: 13,
                bold: true,
                margin: [0, 0, 0, 8]
            },

            // Información de la sesión
            {
                table: {
                    widths: ["100%"],
                    body: [
                        [{ text: `Caja: ${datosCaja.nombre}`, fontSize: 8, style: "infoText" }],
                        [{ text: `Usuario: ${datosUsuario.nombre} ${datosUsuario.apellidoPaterno} ${datosUsuario.apellidoMaterno}`, fontSize: 8, style: "infoText" }],
                        [{ text: `Fecha inicial: ${moment(datosSesion.fechaInicial).format("DD/MM/YYYY HH:mm")}`, fontSize: 8, style: "infoText" }],
                        [{ text: `Fecha final: ${moment(datosSesion.fechaFinal).format("DD/MM/YYYY HH:mm")}`, fontSize: 8, style: "infoText" }]
                    ]
                },
                layout: "noBorders",
                margin: [0, 0, 0, 8]
            },

            // Resumen de Efectivo
            {
                text: "RESUMEN DE EFECTIVO",
                style: "sectionHeader",
                alignment: "center",
                fontSize: 9,
                bold: true,
                margin: [0, 0, 0, 3]
            },

            {
                table: {
                    widths: ["*", "auto"],
                    body: [
                        [
                            { text: "Saldo Inicial:", fontSize: 7, style: "tableText", fillColor: "#f5f5f5" },
                            { text: dineroDisabledMask(datosSesion.saldoInicial), fontSize: 8, style: "tableText", alignment: "right", fillColor: "#f5f5f5" }
                        ],
                        [
                            { text: "Ventas Efectivo:", fontSize: 7, style: "tableText" },
                            { text: dineroDisabledMask(datosSesion.totalEfectivo), fontSize: 8, style: "tableText", alignment: "right" }
                        ],
                        [
                            { text: "Ingresos:", fontSize: 7, style: "tableText", fillColor: "#f5f5f5" },
                            { text: dineroDisabledMask(totalIngresos), fontSize: 8, style: "tableText", alignment: "right", fillColor: "#f5f5f5" }
                        ],
                        [
                            { text: "Retiros:", fontSize: 7, style: "tableText" },
                            { text: "- " + dineroDisabledMask(totalRetiros), fontSize: 8, style: "tableText", alignment: "right" }
                        ],
                        [
                            { text: "SALDO FINAL:", fontSize: 7, style: "tableText", bold: true, fillColor: "#f5f5f5" },
                            { text: dineroDisabledMask(datosSesion.saldoFinal || 0), fontSize: 9, style: "tableText", bold: true, alignment: "right", fillColor: "#f5f5f5" }
                        ]
                    ]
                },
                layout: {
                    hLineWidth: function (i, node) {
                        return (i === node.table.body.length - 1) ? 1 : 0;
                    },
                    vLineWidth: function () { return 0; },
                    hLineColor: function () { return "#666"; }
                },
                margin: [0, 0, 0, 8]
            },

            // Resumen de Ventas
            {
                text: "RESUMEN DE VENTAS",
                style: "sectionHeader",
                alignment: "center",
                fontSize: 9,
                bold: true,
                margin: [0, 0, 0, 3]
            },

            {
                table: {
                    widths: ["*", "auto"],
                    body: [
                        [
                            { text: "Número de Ventas:", fontSize: 7, style: "tableText", fillColor: "#f5f5f5" },
                            { text: datosVentas.count.toString(), fontSize: 8, style: "tableText", alignment: "right", fillColor: "#f5f5f5" }
                        ],
                        [
                            { text: "Subtotal:", fontSize: 7, style: "tableText" },
                            { text: dineroDisabledMask(datosVentas.subtotal), fontSize: 8, style: "tableText", alignment: "right" }
                        ],
                        [
                            { text: "Impuestos:", fontSize: 7, style: "tableText", fillColor: "#f5f5f5" },
                            { text: dineroDisabledMask(datosVentas.totalImpuestos), fontSize: 8, style: "tableText", alignment: "right", fillColor: "#f5f5f5" }
                        ],
                        [
                            { text: "Retenciones:", fontSize: 7, style: "tableText" },
                            { text: "- " + dineroDisabledMask(datosVentas.totalRetenciones), fontSize: 8, style: "tableText", alignment: "right" }
                        ],
                        [
                            { text: "TOTAL VENTAS:", fontSize: 7, style: "tableText", bold: true, fillColor: "#f5f5f5" },
                            { text: dineroDisabledMask(datosVentas.totalPagar), fontSize: 9, style: "tableText", bold: true, alignment: "right", fillColor: "#f5f5f5" }
                        ]
                    ]
                },
                layout: {
                    hLineWidth: function (i, node) {
                        return (i === node.table.body.length - 1) ? 1 : 0;
                    },
                    vLineWidth: function () { return 0; },
                    hLineColor: function () { return "#666"; }
                },
                margin: [0, 0, 0, 8]
            },

            // Formas de Pago
            {
                text: "FORMAS DE PAGO",
                style: "sectionHeader",
                alignment: "center",
                fontSize: 9,
                bold: true,
                margin: [0, 0, 0, 3]
            },

            {
                table: {
                    widths: ["*", "auto"],
                    body: [
                        [
                            { text: "Efectivo:", fontSize: 7, style: "tableText", fillColor: "#f5f5f5" },
                            { text: dineroDisabledMask(datosSesion.totalEfectivo), fontSize: 8, style: "tableText", alignment: "right", fillColor: "#f5f5f5" }
                        ],
                        [
                            { text: "Vales:", fontSize: 7, style: "tableText" },
                            { text: dineroDisabledMask(datosSesion.totalVales), fontSize: 8, style: "tableText", alignment: "right" }
                        ],
                        [
                            { text: "Cheque:", fontSize: 7, style: "tableText", fillColor: "#f5f5f5" },
                            { text: dineroDisabledMask(datosSesion.totalCheque), fontSize: 8, style: "tableText", alignment: "right", fillColor: "#f5f5f5" }
                        ],
                        [
                            { text: "Transferencia:", fontSize: 7, style: "tableText" },
                            { text: dineroDisabledMask(datosSesion.totalTransferencia), fontSize: 8, style: "tableText", alignment: "right" }
                        ],
                        [
                            { text: "Tarjeta:", fontSize: 7, style: "tableText", fillColor: "#f5f5f5" },
                            { text: dineroDisabledMask(datosSesion.totalTarjeta), fontSize: 8, style: "tableText", alignment: "right", fillColor: "#f5f5f5" }
                        ]
                    ]
                },
                layout: "noBorders",
                margin: [0, 0, 0, 8]
            },

            // NUEVO: Detalle de Ventas Ultra Compacto
            ...(ventasCompactas.length > 0 ? [
                {
                    text: "DETALLE DE VENTAS",
                    style: "sectionHeader",
                    alignment: "center",
                    fontSize: 8,
                    bold: true,
                    margin: [0, 0, 0, 2]
                },

                {
                    table: {
                        widths: [25, "*", 30], // Anchos muy reducidos
                        body: [
                            [
                                { text: "FOL", fontSize: 6, bold: true, alignment: "center" },
                                // { text: "FECHA", fontSize: 6, bold: true, alignment: "center" },
                                { text: "PAGOS", fontSize: 6, bold: true, alignment: "center" },
                                { text: "TOT", fontSize: 6, bold: true, alignment: "center" }
                            ],
                            ...ventasCompactas
                        ]
                    },
                    layout: {
                        hLineWidth: function (i) {
                            return (i === 0 || i === 1) ? 0.5 : 0;
                        },
                        vLineWidth: function () { return 0; },
                        hLineColor: function () { return "#ccc"; },
                        paddingLeft: function () { return 2; },
                        paddingRight: function () { return 2; },
                        paddingTop: function () { return 1; },
                        paddingBottom: function () { return 1; },
                        fillColor: (rowIndex, node, columnIndex) => {
                            return rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff";
                        },
                    },
                    margin: [0, 0, 0, 5]
                },

                // Leyenda de abreviaciones
                {
                    text: "E=Efectivo TC=TarjCred TD=TarjDeb V=Vales CH=Cheque TR=Transfer",
                    fontSize: 5,
                    alignment: "center",
                    style: "subtext",
                    margin: [0, 0, 0, 5]
                },

            ] : []),

            // Movimientos de caja (solo si hay)
            ...(conceptosRetiros.length > 0 ? [
                // Separador
                {
                    text: "MOVIMIENTOS DE CAJA",
                    style: "sectionHeader",
                    alignment: "center",
                    fontSize: 9,
                    bold: true,
                    margin: [0, 0, 0, 3]
                },

                {
                    table: {
                        widths: ["40%", "25%", "35%"],
                        body: [
                            [
                                { text: "CONCEPTO", fontSize: 7, style: "tableHeader", alignment: "center", bold: true },
                                { text: "TIPO", fontSize: 7, style: "tableHeader", alignment: "center", bold: true },
                                { text: "MONTO", fontSize: 7, style: "tableHeader", alignment: "center", bold: true }
                            ],
                            ...conceptosRetiros
                        ]
                    },
                    layout: {
                        hLineWidth: function (i) {
                            return (i === 0 || i === 1) ? 1 : 0;
                        },
                        vLineWidth: function () { return 0; },
                        hLineColor: function () { return "#666"; }
                    },
                    margin: [0, 0, 0, 8]
                }
            ] : []),

            // Fecha y hora de impresión
            {
                text: `Impreso: ${moment().format("DD/MM/YYYY HH:mm:ss")}`,
                fontSize: 7,
                alignment: "center",
                style: "subtext",
                margin: [0, 0, 0, 5]
            },

            // Observaciones
            {
                text: "Observaciones:",
                style: "sectionHeader",
                fontSize: 8,
                bold: true,
                margin: [0, 5, 0, 2]
            },
            ...(datosSesion.observaciones
                ? [{ text: datosSesion.observaciones, fontSize: 7, style: "tableText", margin: [0, 0, 0, 8] }]
                : [
                    { text: "_".repeat(40), fontSize: 7, margin: [0, 0, 0, 2] },
                    { text: "_".repeat(40), fontSize: 7, margin: [0, 0, 0, 8] }
                ]),

            // Líneas para firmas
            {
                table: {
                    widths: ["*"],
                    body: [
                        [{ text: "FIRMAS", fontSize: 8, alignment: "center", bold: true, margin: [0, 5, 0, 5] }],
                        [{ text: "Cajero:", fontSize: 7, margin: [0, 3, 0, 0] }],
                        [{ text: "________________________", fontSize: 7, margin: [0, 10, 0, 5] }],
                        [{ text: "Supervisor:", fontSize: 7, margin: [0, 3, 0, 0] }],
                        [{ text: "________________________", fontSize: 7, margin: [0, 10, 0, 0] }]
                    ]
                },
                layout: "noBorders"
            }
        ],

        styles: {
            header: {
                bold: true
            },
            title: {
                bold: true
            },
            sectionHeader: {
                bold: true
            },
            subtext: {
                color: "#666"
            },
            infoText: {
                margin: [0, 1, 0, 1]
            },
            tableText: {
                margin: [0, 1, 0, 1]
            },
            tableHeader: {
                fillColor: "#f0f0f0",
                margin: [0, 2, 0, 2]
            }
        },

        defaultStyle: {
            fontSize: 8
        }
    };
};

export default ticketCorteCajaPdf;
